<div class="step-card">
  <form
    [formGroup]="pmpForm"
    (ngSubmit)="onSubmit()"
    class="step-form"
  >
    <div class="form-section">

      <!-- Ligne 1 : Date prévisionelle + Délai -->
      <div class="form-row">
        <div class="field">
          <app-input
            label="Date limite de transmission des spécifications (TDR/DM)"
            formControlName="datePrevision"
            type="date"
          />
          @if (pmpForm.get('datePrevision')?.touched && pmpForm.get('datePrevision')?.invalid) {
            <small class="field-error">La date de prévision est requise.</small>
          }
        </div>
        <div class="field">
          <app-input
            label="Délai de passation du marché (en jours)"
            formControlName="delaiNeccessairePassationMarche"
            type="number"
          />
          @if (pmpForm.get('delaiNeccessairePassationMarche')?.touched && pmpForm.get('delaiNeccessairePassationMarche')?.invalid) {
            <small class="field-error">Le délai de passation est requis.</small>
          }
        </div>
      </div>

      <!-- Ligne 2 : Durée + Échéance calculée -->
      <div class="form-row">
        <div class="field">
          <app-input
            label="Durée prévisionnelle d'exécution du marché (en jours)"
            formControlName="dureePrevisionExecutionMarche"
            type="number"
          />
          @if (pmpForm.get('dureePrevisionExecutionMarche')?.touched && pmpForm.get('dureePrevisionExecutionMarche')?.invalid) {
            <small class="field-error">La durée d'exécution est requise.</small>
          }
        </div>
        <div class="field">
          <div class="computed-field">
            <app-input
              label="Échéance de satisfaction du besoin"
              formControlName="echeanceSatisfaction"
              type="date"
            />
            <p class="computed-hint">
              <span class="material-icons computed-hint__icon">auto_fix_high</span>
              Calculée automatiquement à partir des champs précédents
            </p>
          </div>
        </div>
      </div>

    </div>

    <!-- Actions -->
    <div class="actions">
      <button type="button" class="btn btn-secondary btn-md" (click)="goBack()">
        <span class="material-icons btn-icon btn-icon--left">arrow_back</span>
        Précédent
      </button>
      <button type="submit" class="btn btn-primary btn-md">
        Suivant
        <span class="material-icons btn-icon btn-icon--right">arrow_right_alt</span>
      </button>
    </div>

  </form>
</div>